<!-- JAVASCRIPT START -->
<script>
  import { createEventDispatcher } from 'svelte';

  import Button from '../shared/Button.svelte';
  import Modal from '../shared/Modal.svelte';
  import ModalContent from '../shared/ModalContent.svelte';
  import FooterPrice from '../shared/FooterPrice.svelte';
  import SidebarTitle from '../shared/SidebarTitle.svelte';
  import Toggle from '../shared/Toggle.svelte';

  const dispatch = createEventDispatcher();
  
  ////////////////
  // Variables
  ////////////////
  export let showPricing = true;
  let selectedCheckbox = [];
  let selectedRadio;	
  let isRadio;
  let optionsSubtotal = formatPrice(0);
  let capacity;


  ////////////////
  // Data
  ////////////////
  const data = {
      "title" : "Select Base System",
      "required" : true,
      "multiselect" : false,
      "globalSortOrder" : 1,
      "options" : [
          {
              "id" : 1001,
              "name" : "Tube Store",
              "price" : 79000,
              "showPriceInButton" : false,
              "capacityDetails" : 
                {
                  "title" : "Tube Storage Capacity",
                  "options" : [
                    "0.3 mL (screw cap) 28,000-36,000",
                    "1.0 mL (DuraSeal) 15,000-18,000"
                  ]
                }
          },
          {
              "id" : 1002,
              "name" : "Plate Store",
              "price" : 69930,
              "showPriceInButton" : false,
              "capacityDetails" : 
                {
                  "title" : "Plate Storage Capacity",
                  "options" : [
                    "Shallow Well Plates 315",
                    "Half Height Plates 185"
                  ]
                }
          },
      ],
      "titleToolTip" : `
        <h2>Choosing your base system</h2>
        <div>
          <p><strong>Tube Store</strong> - Fully Automated Storage System for Tubes and Plates</p>
          <hr>
          <p><strong>Plate Store</strong> - Fully Automated Storage System for Plates</p>
        </div>
      `
  };


  ////////////////
  // Funtions
  ////////////////
  function handleSubmitClick() {
    dispatch('nextStep', fetchCartItems());
  }

  function fetchCartItems() {
    let cartItems = [];

    //add madatory radio item
    if(selectedRadio){
      cartItems.push(data.options[selectedRadio.index]);
    }

    //add checkboxes
    if(selectedCheckbox.length > 0){

      for(let i=0; i <= data.options.length - 1; i++) {
        if (data.options[i].dependentOptions){
          for(let j=0; j <= data.options[i].dependentOptions.length - 1; j++) {
            cartItems.push(data.options[1].dependentOptions[j]);
          }
        }
      }
    }

    return cartItems;
  }

  const updatePageDetails = (optionIndex) => {
    capacity = data.options[optionIndex.detail.index];
    updateSubtotal(optionIndex);
  }

  const updateSubtotal = (optionIndex) => {
    optionsSubtotal = formatPrice(data.options[optionIndex.detail.index].price);
  }
  
  function formatPrice(num){
		let formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});

		return formatter.format(num);
	}
</script>
<!-- JAVASCRIPT END -->



<!-- STYLES START -->
<style>
  
  @media (min-width: 1024px) {
    .bg {
      background-image: url(/img/baseSystem--hero@3x.jpg);
    }
  }

</style>
<!-- STYLES END -->



<!-- HTML START -->
<!-- desktop images -->
<link rel="preload" href="img/pickerOptions--hero@3x.jpg" as="image" media="(min-width: 1024px)">

<!-- mobile images -->
<link rel="preload" href="img/pickerOptions--hero.jpg" as="image" media="(max-width: 1023px)">

<!-- misc images -->
<link rel="preload" href="img/pickerOptions96EndEffector@3x.jpg" as="image">
<link rel="preload" href="img/pickerOptionsUniversalEndEffector@3x.jpg" as="image">


<div class="relative lg:h-full lg:overflow-y-hidden">
  <div class="bg absolute top-0 left-0"></div>
	<div class="relative z-10 lg:h-full lg:overflow-y-scroll">
    <div class="flex flex-col lg:flex-row flex-no-wrap w-100 text-lg">
      <div class="flex-column flex-1"></div>
      <div class="flex-column flex-1">
        <div class="bg-white lg:my-12 lg:mb-12 lg:mx-10 lg:rounded lg:shadow-2xl">

          <div class="lg:hidden">
            <img class="w-full md:w-1/2 md:m-auto md:mt-10" src="/img/baseSystem--hero.jpg" alt="Verso Q20 rendering">
          </div>

          <SidebarTitle title={data.title} titleToolTip={ data.titleToolTip } />
          
          <main class="flex-grow p-10">

            {#each data.options as option, i (option.id)}
              <Toggle type='radio' bind:group={selectedRadio} value={ {"index" : i} } let:checked={checked} buttonLabel={option.name} buttonPrice={option.showPriceInButton} price={option.price} id={option.id} index={i} on:toggle={updatePageDetails} classes='m-2' />
            {/each}

            <p class="text-gray-600 text-xl text-center py-6">All Verso Q20 Systems are available with a storage temperature configurable from +20&deg;C to -20&deg;C.</p>

            {#if capacity !== undefined}
              <table class="table-auto w-full text-gray-600">
                <thead>
                  <tr class="bg-gray-200">
                    <th class="px-4 py-2 text-left uppercase text-gray-700" style="font-family: Camphor W01 Bold;">{capacity.capacityDetails.title}</th>
                  </tr>
                </thead>
                <tbody>
                  {#each capacity.capacityDetails.options as option}
                  <tr>
                    <td class="border px-4 py-2">{option}</td>
                  </tr>
                  {/each}
                </tbody>
              </table>
            {/if}
          </main>

          <footer class="nav flex flex-shrink lg:rounded-b px-10 py-6"> 
              {#if showPricing}
                <FooterPrice subtotal={optionsSubtotal} />
              {/if}

              <div class="flex-1">
                <Button disabled={data.required && !selectedRadio} title="Next Step" id="submitButton" on:click={handleSubmitClick} />
              </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HTML END -->